import React from 'react';
import AutoTechWebsite from './components/AutoTechWebsite';
import './App.css';

function App() {
  return (
    <div className="App">
      <AutoTechWebsite />
    </div>
  );
}

export default App;